import styled from 'styled-components';
export const FlexContainer = styled.section.withConfig({ displayName: "brc-sc-FlexContainer", componentId: "brc-sc-ta24iz" }) `
  display: flex;
  flex-flow: ${(props) => props.flexFlow || 'row wrap'};
  align-content: ${(props) => props.alignContent || 'flex-start'};
  align-items: ${(props) => props.alignItems || 'flex-start'};
  justify-content: ${(props) => props.justifyContent || 'flex-start'};
  flex: ${(props) => props.flex || ''};
  max-width: 100%;
`;
FlexContainer.displayName = 'FlexContainer';
//# sourceMappingURL=index.js.map